import { Space } from 'antd'
import {
  ActionMenu,
  ButtonText,
  Main,
  StyledDropDownButton,
} from 'components/ActionStyles/ActionStyles'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Drawer from 'components/Drawer'
import FileReader from 'components/Uploader/FileReader'
import Uploadloader from 'components/Uploader/Uploader'
import DownArrow from 'components/icons/DownArrow'
import Download from 'components/icons/Download'
import ErrorInfoTable from 'modules/Students/Partials/StudentsBulkUpload/Partials/ErrorInfoTable'
import StatusMessage from 'modules/Students/Partials/StudentsBulkUpload/Partials/StatusMessage'
import {
  BoldText,
  ErrorMessage,
  FooterFlex,
  Form,
  InfoSection,
  LightText,
  SampleDocContainer,
  SmallButtons,
} from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import SuccessMessage from 'utils/SuccessMessage'
import studentBulkTemplate from 'utils/studentBulkTemplate'
import studentRequest from 'utils/studentRequest'

const StudentsBulkUpload = ({
  uploadDrawer,
  setUploadDrawer,
  getStudentsListData,
  getFilterDegreeData,
}) => {
  const instituteCampusId = useSelector(state => state.auth.instituteDetails.id)

  const [file, setFile] = useState('')
  const [fileName, setFileName] = useState('')
  let courseId = ''
  const [isUploaded, setIsUploaded] = useState(true)
  const showStatus = false
  const [showErrorTable, setShowErrorTable] = useState(false)
  const [errorData, setErrorData] = useState({})
  useEffect(() => {
    let query = 'getAllCourses=true'
    getFilterDegreeData(query)
  }, [])

  const onFileUploaded = file => {
    setFile(file)
    setIsUploaded(true)
    setShowErrorTable(false)
  }
  const onSubmitFormData = data => {
    if (!file?.name) {
      setIsUploaded(false)
      return
    }
    let payLoad = {
      courseId: courseId,
      excelFileLink: file?.url,
      instituteCampusId,
    }
    bulkUploadStudents(payLoad)
  }
  const bulkUploadStudents = async payload => {
    try {
      await studentRequest.post(`/students/bulkcreate`, payload)
      SuccessMessage('Students Created Successfully..')
      getStudentsListData()
      setUploadDrawer(false)
      return true
    } catch (error) {
      setErrorData(error?.response?.data?.data?.failedRecords)
      setShowErrorTable(true)
    }
  }
  const downloadURI = () => {
    let uri = studentBulkTemplate
    let name = 'SampleDoc'
    let link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  const content = () => {
    const menu = <ActionMenu width={'165px'} items={[]} />
    return (
      <Fragment>
        {!showStatus ? (
          <Fragment>
            <InfoSection>
              <Space>
                <SmallButtons
                  height={'30px'}
                  width="30px"
                  border={true}
                  icon={<Download />}
                />
                <SampleDocContainer>
                  <BoldText>Candidate Sample Doc</BoldText>
                  <LightText>
                    To Upload bulk upload data, use template
                  </LightText>
                </SampleDocContainer>
              </Space>
              <Main>
                <StyledDropDownButton
                  overlay={menu}
                  shape="round"
                  onClick={downloadURI}
                  trigger={['click']}
                  icon={<DownArrow />}
                >
                  <ButtonText>Download</ButtonText>
                </StyledDropDownButton>
              </Main>
            </InfoSection>
            <Form
              scrollToFirstError
              onFinish={onSubmitFormData}
              id="bulkUpload"
              layout="vertical"
            >
              <Control column top="20px" center>
                <Uploadloader
                  setFile={onFileUploaded}
                  isDefault={true}
                  fileName={fileName}
                  setFileName={setFileName}
                />
                {!isUploaded && <ErrorMessage>Upload file..</ErrorMessage>}
              </Control>
              {file && (
                <Control column top="20px" center>
                  <FileReader file={file} setFile={setFile} />
                </Control>
              )}
            </Form>
            {showErrorTable && file && <ErrorInfoTable data={errorData} />}
          </Fragment>
        ) : (
          <StatusMessage />
        )}
      </Fragment>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setUploadDrawer(false)
          }}
        />
        <Button.Primary htmlType="submit" form="bulkUpload" text="Upload" />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="40%"
      title={'Bulk Upload'}
      placement="right"
      closable={true}
      visible={uploadDrawer}
      content={content()}
      footer={footer()}
      onClose={() => setUploadDrawer(false)}
    />
  )
}

export default StudentsBulkUpload
